import { useState, useEffect } from "react";
import MainContainer from "../../components/app/maincontainer";
import { FaChevronLeft, FaChevronRight, FaTimes } from "react-icons/fa";
import Upload from "../../assets/icons/upload.svg";
import { MdDelete } from "react-icons/md";
import { useNavigate, useLocation } from "react-router-dom";
import { NewInput } from "../../components/inputs/main";
import PrimaryBtn, { MainBtn } from "../../components/app/buttons";
import DoneModal from "../../components/modals/donemodal";
import { combineArray } from "../../data/useExtractor";
import { toast } from "react-toastify";
import { IoIosAdd } from "react-icons/io";
import { apiCall } from "../../data/useFetcher";
import useErrorStore from "../../data/stores/errorStore";
import { AddUsersModal } from "../../components/modals/addtoolsmodal";
import RawSample from "../../assets/Tool Category Sample.xlsx";

const AddData = () => {
	const navigate = useNavigate(),
		[modal, setModal] = useState("");

	let [loading, setLoading] = useState(null),
		{ returnErrors } = useErrorStore(),
		location = useLocation()?.state;

	// console.log({ location });

	let init2: { category?: string; data?: string; dataArr?: string[] } = {};
	const [itemForm, setItemForm] = useState([init2]);
	const handleInputChangeForMutipleItem = (
		e: React.ChangeEvent<HTMLInputElement> | any,
		index: number,
		field: string
	) => {
		const { value } = e?.target;
		let itemValue = value;

		setItemForm(prevRows => {
			const newRows = [...prevRows];
			newRows[index][field] = itemValue;
			return newRows;
		});
	};

	const handleDeleteRowForMutipleItem = (index: number) => {
		setItemForm(prevRows => {
			const newRows = [...prevRows];
			newRows.splice(index, 1);
			return newRows;
		});
	};

	const handleInputKeyPress = (
		e: React.KeyboardEvent<HTMLInputElement>,
		index: number,
		field: string
	) => {
		console.log({ e });

		setItemForm(prevRows => {
			const newRows = [...prevRows];
			// console.log({ e: e.key });
			let emailInput = newRows[index].data;
			if (e.key === "Enter" && emailInput.trim() !== "") {
				e?.preventDefault(); // This prevents the default form submission behavior
				newRows[index][field] = Array.isArray(newRows[index][field])
					? [...newRows[index][field], emailInput.trim()]
					: [emailInput.trim()];
				newRows[index].data = "";
			}
			return newRows;
		});
	};

	const addRowForMutipleItem = () => {
		const newRow = init2;
		setItemForm([...itemForm, newRow]);
	};

	let [pres, setPres] = useState<any>(null);

	const [bulkUpload, setBulkUpload] = useState(false);
	const toggleUploadModal = () => {
		setPres(null);
		setBulkUpload(false);
	};

	const onSubmit2 = async () => {
		console.log({ pres, location });
		if (pres?.length === 0 && location?.length === 0)
			return toast.info("Rawdata' details required");

		try {
			// let newPres = [];
			// for (let p = 0; p < pres.length; p++) {
			// 	const element = pres[p];
			// 	newPres?.push(toCamel(element));
			// }
			// let newNewPres = newPres?.map(it => {
			// 	let data = it?.data?.split("\r\n")?.map(ix => ix?.trim());
			// 	return { ...it, data };
			// });

			let newItemForm = combineArray(location || pres),
				newerItemForm = [];
			// console.log({ newItemForm });
			for (let n = 0; n < newItemForm?.length; n++) {
				let element = newItemForm?.[n];
				for (let c = 0; c < element?.length; c++) {
					let elementC = element?.[c],
						findIn = newerItemForm?.find(
							ir => ir?.category === elementC?.category
						);
					if (findIn) {
						// console.log({ ele: elementC?.data, fiIn: findIn?.data });
						let newD = [];
						if (findIn?.data && Array.isArray(findIn?.data))
							newD = [...newD, ...findIn?.data];
						if (elementC?.data && Array.isArray(elementC?.data))
							newD = [...newD, ...elementC?.data];
						findIn.data = newD;
						newerItemForm = newerItemForm?.map(ix =>
							ix?.category === findIn?.category ? findIn : ix
						);
					} else {
						newerItemForm?.push(elementC);
					}
				}
			}
			console.log({ newItemForm, newerItemForm });
			let newItem = [];
			for (let n = 0; n < newerItemForm?.length; n++) {
				const element = newerItemForm?.[n];
				newItem = [
					...newItem,
					{
						...element,
						category: element?.category,
						dataArr: element?.data,
						data: "",
					},
				];
			}
			setItemForm(
				itemForm?.[0]?.category && !location
					? [...itemForm, ...newItem]
					: newItem
			);

			toggleUploadModal();
		} catch (err) {
			if (err) console.log({ error: err.response?.data, err });
		}
	};

	useEffect(() => {
		if (location || pres) onSubmit2();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location, pres]);

	// console.log({ itemForm });

	const onSubmit = async (event?: React.FormEvent<HTMLFormElement>) => {
		event?.preventDefault();
		if (itemForm?.length === 0) return toast.info("Data set required");
		if (itemForm?.length === 1)
			if (!itemForm?.[0]?.category || itemForm?.[0]?.dataArr?.length === 0)
				return toast.info("Data set required");

		setLoading(true);

		let { response, errArr, errMsg } = await apiCall({
			type: "post",
			url: `/api/v1/rawdata`,
			data: {
				rawdata: itemForm?.map(item => {
					return {
						...item,
						data: item?.dataArr?.map(it => {
							return {
								title: it?.trim(),
							};
						}),
					};
				}),
			},
		});
		// console.log({ response, errArr, errMsg });
		if (errArr) {
			setLoading(false);
			return returnErrors(errArr);
		}
		if (errMsg) {
			setLoading(false);
			return toast.error(errMsg);
		}
		setLoading(false);
		if (response) {
			setModal("done");
			return;
		}
		setLoading(false);
		setLoading(false);
	};

	return (
		<div>
			<MainContainer>
				<div className="mt-8 flex justify-between items-center">
					<div className="flex gap-2">
						<FaChevronLeft
							color="#334155"
							onClick={() => navigate(-1)}
							className="cursor-pointer mt-1"
						/>
						<div>
							<h1 className="text-xl font-semibold text-da-blue-600 inter">
								Add Data
							</h1>
							<div className="flex gap-2 items-center">
								<span className="text-base font-normal text-[#334155]">
									Data List
								</span>
								<FaChevronRight color="#334155" size={10} />
								<span className="text-base font-normal text-[#334155]">
									Add Data
								</span>
							</div>
						</div>
					</div>
				</div>
				<div className="mt-12 bg-white min-h-screen w-full p-8">
					<div
						style={{
							borderBottom: "1px solid #E2E8F0",
						}}
						className="h-full w-full pb-3 flex justify-between">
						<h4 className="text-xl font-semibold inter text-da-blue-600">
							Data
						</h4>
						<PrimaryBtn
							color={"#3787FF"}
							onClick={() => setBulkUpload(!bulkUpload)}
							icon={Upload}
							text={"Bulk Upload"}
							bg={"transparent"}
							className="border border-da-blue-100"
						/>
					</div>
					<form className="mt-6" onSubmit={onSubmit}>
						{itemForm?.map((item, index) => (
							<>
								<div className="relative grid md:grid-cols-3  w-4/5 gap-5">
									<div>
										<NewInput
											onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
												handleInputChangeForMutipleItem(e, index, "category")
											}
											value={item.category}
											label={index === 0 ? "DataSet Category" : ""}
											placeholder={"Category dataset"}
										/>
									</div>
									<div className="col-span-2">
										<div>
											{index === 0 && (
												<label className="text-[#334155] font-medium text-sm inter">
													DataSet data*
												</label>
											)}
											<div className="">
												{item?.dataArr?.length > 0 && (
													<div className="flex items-center gap-2 overflow-x-auto py-2 px-3">
														{item?.dataArr?.map((it, x) => (
															<span
																key={x}
																className="text-xs border border-black rounded-full px-3 py-1 flex items-center justify-between gap-3 w-auto whitespace-nowrap">
																{it}{" "}
																<FaTimes
																	className="cursor-pointer"
																	onClick={() => {
																		let newArr = item?.dataArr?.filter(
																			(j, k) => k !== x
																		);
																		let newItem = {
																			...item,
																			dataArr: newArr,
																		};
																		let newFinal = itemForm?.map((it, d) =>
																			d === index ? newItem : it
																		);
																		setItemForm(newFinal);
																		// setItemForm(prevRows => {
																		// 	const newRows = [...prevRows];
																		// 	newRows[index].dataArr?.splice(x, 1);
																		// 	return newRows;
																		// });
																	}}
																/>
															</span>
														))}
													</div>
												)}
												<NewInput
													onKeyUp={(e: React.KeyboardEvent<HTMLInputElement>) =>
														handleInputKeyPress(e, index, "dataArr")
													}
													placeholder="Press Enter to input a new Dataset data"
													onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
														handleInputChangeForMutipleItem(e, index, "data")
													}
													value={item.data}
													label={""}
												/>
											</div>
										</div>
									</div>
									<div
										onClick={() => handleDeleteRowForMutipleItem(index)}
										className="md:absolute self-center -right-20 cursor-pointer">
										<p className="text-sm text-red-600 flex items-center md:mt-2 gap-2">
											<span>
												<MdDelete />
											</span>
											Remove
										</p>
									</div>
								</div>
							</>
						))}
						<p
							onClick={addRowForMutipleItem}
							className="flex items-center gap-2 text-bluerolodex f-medium my-3 cursor-pointer">
							<span>
								<IoIosAdd />
							</span>
							Add dataset
						</p>
						<div className="flex mt-9 gap-5">
							<MainBtn
								onClick={() => navigate(-1)}
								className="border border-[#FECACA]"
								text={"Discard"}
								bg={"transparent"}
								color={"#EF4444"}
								type="button"
								disabled={loading}
							/>
							<MainBtn
								text={"Continue"}
								bg={"#3787FF"}
								color={"white"}
								loading={loading}
								type="button"
								onClick={() => onSubmit()}
							/>
						</div>
					</form>
				</div>
				{modal === "done" && (
					<DoneModal
						page={"Data"}
						handleClose={() => setModal("")}
						path={"/data"}
					/>
				)}
				{bulkUpload && (
					<AddUsersModal
						handleClose={toggleUploadModal}
						title={"Upload new data list"}
						subtitle="Add new data"
						handleImport={pres2 => {
							setPres(pres2);
						}}
						sample={RawSample}
					/>
				)}
			</MainContainer>
		</div>
	);
};

export default AddData;
